module.exports = __webpack_public_path__ + "img/error.876ffb3c.svg";